/**
 * 콘텐츠 제작 가이드 바텀시트 정적 상수.
 *
 * NOTE: PRD §2-6 / §2-7 / §3-4 기반 초안 문구. 디자이너/PO 컨펌 후 최종 카피 반영 필요.
 * 캠페인별 다르지 않은 고정 가이드이므로 features-layer 정적 상수로 관리.
 * 향후 브랜드별 동적 문구가 필요해지면 SeedingCampaignDetail DTO 확장으로 마이그레이션.
 */

import type { ContentGuideInfoSheetSection } from '../common/ContentGuideInfoSheet';

interface ContentGuideInfoSheet {
  /** 시트 헤더 타이틀 */
  title: string;
  sections: ContentGuideInfoSheetSection[];
}

// Figma 1704-41331 정합 — 필수 해시태그 / 브랜드사 요청 사항 / 광고 표시 안내 3섹션. (피드백 항목17)
export const CONTENT_GUIDE_INFO_SHEET: ContentGuideInfoSheet = {
  title: '콘텐츠 제작 가이드',
  sections: [
    {
      title: '필수 해시태그',
      items: [
        '게시물 작성 시 필수 해시태그를 입력해 주세요.',
        '#광고 해시태그는 반드시 게시물 본문의 최상단 첫 번째에 작성해 주세요.',
      ],
    },
    {
      title: '브랜드사 요청 사항',
      items: ['브랜드사의 요청 사항을 확인하신 후 콘텐츠를 제작해 주세요.'],
    },
    {
      title: '광고 표시 안내',
      items: [
        'SNS 콘텐츠, 당사 리뷰 및 스냅 등의 게시글에 경제적 대가(상품 협찬)을 받은 사실을 명확히 고지해 주세요.',
        '(예시) 본 게시글은 브랜드사로부터 제품을 무상으로 제공받아 작성된 후기입니다.',
      ],
    },
  ],
} as const;
